import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

const PrelaunchHeader = () => {
  return (
    <Container className="px-sm-0 ps-3">
      <Navbar expand="lg" className="position-relative">
        <Navbar.Brand>
          <img src="/assets/imgs/black-logo.svg" alt="" width={60} height={60} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto gap-3 handleLarger"></Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
};

export default PrelaunchHeader;
